var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bgColor",staticClass:"dict_header"},[_c('div',{staticClass:"header_box"},[_c('swiper-main',{staticClass:"swiper",on:{"changeBg":_vm.swapColor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }